import { UseQueryOptions } from "@tanstack/react-query";
import { useGeneralQueryWithoutToken } from "../useGeneralQuery";
import { AxiosResponse } from "axios";

export const useGetUserByPhone = (params: { phone?: string }, options: UseQueryOptions<AxiosResponse<any>, Error> = {}) =>
	useGeneralQueryWithoutToken<{
		id: number;
		nickName: string;
		fio: string;
		pinfl: string;
		authTypeId: number;
		ns10: number;
		ns11: number;
		createdAt: string;
		updatedAt: string;
		phone: string;
		cardId: number;
		resident: number;
		activityType: number;
	}>("/auth/get-user-by-phone", params, options);
